import React, { useState } from "react";
import "./SearchableDropdown.css";

interface User {
  id: string;
  full_name: string;
  email: string;
  avatar?: string;
}

interface SearchableDropdownProps {
  users: User[];
  isOpen: boolean;
  onClose: () => void;
  selected: string[]; // array of selected user ids
  onSelect: (ids: string[]) => void;
}

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({
  users,
  isOpen,
  onClose,
  selected,
  onSelect,
}) => {
  const [search, setSearch] = useState("");

  if (!isOpen) return null;

  const filteredUsers = users.filter(
    (u) =>
      u.full_name.toLowerCase().includes(search.toLowerCase()) ||
      u.email.toLowerCase().includes(search.toLowerCase())
  );

  const handleToggle = (id: string) => {
    if (selected.includes(id)) {
      onSelect(selected.filter((uid) => uid !== id));
    } else {
      onSelect([...selected, id]);
    }
  };

  return (
    <div className="searchable-dropdown__overlay" onClick={onClose}>
      <div
        className="searchable-dropdown__modal"
        onClick={(e) => e.stopPropagation()}
      >
        <input
          className="searchable-dropdown__input"
          type="text"
          placeholder="Search users..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="searchable-dropdown__list">
          {filteredUsers.length === 0 && (
            <div className="searchable-dropdown__empty">No users found.</div>
          )}
          {filteredUsers.map((user) => (
            <div
              key={user.id}
              className={`searchable-dropdown__item ${
                selected.includes(user.id) ? "selected" : ""
              }`}
              onClick={() => handleToggle(user.id)}
            >
              <img
                src={
                  user.avatar ||
                  "https://ui-avatars.com/api/?name=" +
                    encodeURIComponent(user.full_name)
                }
                alt={user.full_name}
                className="searchable-dropdown__avatar"
              />
              <div className="searchable-dropdown__info">
                <div className="searchable-dropdown__name">
                  {user.full_name}
                </div>
                <div className="searchable-dropdown__email">{user.email}</div>
              </div>
              <div className="searchable-dropdown__checkbox">
                <input
                  type="checkbox"
                  checked={selected.includes(user.id)}
                  readOnly
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchableDropdown;
